import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  clusters: [],
  loading: false,
  error: null
};

const clustersSlice = createSlice({
  name: 'clusters',
  initialState,
  reducers: {
    setClusters: (state, action) => {
      state.clusters = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const { setClusters, setLoading, setError } = clustersSlice.actions;
export default clustersSlice.reducer;
